const t={defaultFlagValue:"Control",isDisabledForUHC:!0,isCustomAnalytics:!1,isInteractionEvent:!1,extraConditions:[]};export{t as defaultExpOptions};
//# sourceMappingURL=constants.js.map
